import * as React from 'react';

import { Button, Dialog, Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/grading';

type Props = {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const SwitchToLegacyGraderConfirmation = ({ isOpen, onConfirm, onCancel }: Props) => {
  const { Actions, Content, HeadingGroup } = Dialog;
  return (
    <Dialog
      open={isOpen}
      variant="standard"
      width="large"
      onClose={onCancel}
      aria-describedby="confirm-switch-to-legacy-grader-content"
    >
      <HeadingGroup>{_t('You’re switching to classic grader')}</HeadingGroup>
      <Content id="confirm-switch-to-legacy-grader-content">
        <Typography2 component="p" variant="bodyPrimary">
          {_t(
            'The grading experience change is temporary and will be reverted back once you close browser window. You can always use the new grading experience by switching on the next screen.'
          )}
        </Typography2>
      </Content>
      <Actions>
        <Button onClick={onConfirm}>{_t('Continue')}</Button>
      </Actions>
    </Dialog>
  );
};

export default SwitchToLegacyGraderConfirmation;
